import React, { useContext } from "react";
import { Button } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import classnames from "classnames";
import { Dispatch } from "./store/store";
import style from "./IO.module.scss";
import { onChangeMode } from "./IO";
import { Mode } from "../../../utils";

const Footer = ({ toggle, buttons, actions }) => {
  const { dispatch } = useContext(Dispatch);
  const { precheck, modify, confirm } = buttons;

  if (precheck.loading) {
    setTimeout(() => {
      onChangeMode(dispatch, Mode.CONFIRM);
    }, 300);
  }

  return (
    <div>
      <Button color="light" onClick={() => toggle()}>
        Close
      </Button>{" "}
      {modify.visible && (
        <Button color="light" onClick={() => onChangeMode(dispatch, Mode.EDIT)}>
          {"Modify"}
        </Button>
      )}{" "}
      {precheck.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={precheck.loading}
          onClick={() => onChangeMode(dispatch, Mode.PRECHECK)}
          data-style={EXPAND_RIGHT}
        >
          {"Pre check"}
        </LaddaButton>
      )}
      {confirm.visible && (
        <LaddaButton
          className={classnames("btn btn-ladda btn-primary")}
          loading={confirm.loading}
          onClick={actions.confirm}
          data-style={EXPAND_RIGHT}
        >
          {"Confirm"}
        </LaddaButton>
      )}
    </div>
  );
};

export default Footer;
